// extracted by mini-css-extract-plugin
export default {"integrationsFieldCollapsed":"integrationsFieldCollapsed___vq8ec"};